import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { patientAllergyActions, consultationActions } from '@actions';
import styled from '@emotion/styled/macro';

import { Lab, PlusIcon } from '@images';
import { Breadcrumb, H1, Add, Pagination, StateCard, Modal } from '@utils';
import { Container, RequestMedicalRecordForm } from '@components';
import { Link } from 'react-router-dom';

const AllergiesWrapper = styled.div`
  h1 {
    font-size: 30px;
  }
  a {
    font-family: AvenirNext;
    font-size: 14px;
    font-weight: 500;
    color: #9298ac;
  }
  .ant-breadcrumb-separator {
    margin-right: 5px;
    color: #9298ac;
  }
  .add {
    margin-bottom: 25px;
  }
  .pagination {
    max-width: 780px;
    margin-left: 0;
  }
  .request {
    display: block;
    margin: 15px 0;
    color: #5cb3db;
    img {
      margin-right: 10px;
      width: 25px;
      height: 25px;
      margin-top: 20px;
      position: relative;
      top: -11px;
    }
  }
`;

class Allergies extends Component {
  componentDidMount() {
    const {
      getAllergies,
      match: {
        params: { patientId },
      },
      getSharedAllergies,
    } = this.props;
    const sharedToken = new URLSearchParams(this.props.location.search).get(
      'sharedToken'
    );
    if (patientId && !sharedToken) {
      getSharedAllergies(patientId);
    } else if (patientId && sharedToken) {
      getSharedAllergies(patientId, sharedToken);
    } else {
      getAllergies();
    }
  }
  state = {
    showModal: false,
  };

  handelCloseModal = () => {
    this.setState({ showModal: false });
  };

  handelShowModal = () => {
    this.setState({ showModal: true });
  };

  setPage = page => {
    const {
      getAllergies,
      match: {
        params: { patientId },
      },
      getSharedAllergies,
    } = this.props;
    const sharedToken = new URLSearchParams(this.props.location.search).get(
      'sharedToken'
    );
    if (patientId && !sharedToken) {
      getSharedAllergies(patientId, null, page);
    } else if (patientId && sharedToken) {
      getSharedAllergies(patientId, sharedToken, page);
    } else {
      getAllergies(page);
    }
  };

  render() {
    const userType = localStorage.getItem('userType');
    const sharedToken = new URLSearchParams(this.props.location.search).get(
      'sharedToken'
    );
    const RequestConsultation = new URLSearchParams(
      this.props.location.search
    ).get('RequestConsultation');
    const {
      allergies,
      match: {
        params: { consultationId, patientId },
      },
      requestScan,
    } = this.props;
    const BreadcrumbLinks = consultationId
      ? [
          {
            item: 'Medical Record ',
            url: `/consultant/consultation/${consultationId}`,
          },
        ]
      : sharedToken
      ? [
          {
            item: 'Medical Record ',
            url: `/${patientId}/shared-data?sharedToken=${sharedToken}`,
          },
        ]
      : RequestConsultation
      ? [{ item: 'Request Consultation ', url: '/request-consultation' }]
      : [{ item: 'Medical Record ', url: '/#MedicalRecord' }];

    const { showModal } = this.state;
    return (
      <Container>
        <AllergiesWrapper>
          <Breadcrumb links={BreadcrumbLinks} />
          <H1>Allergies</H1>

          {userType === 'consultant' && !sharedToken && (
            <Link
              className="request"
              to="#!"
              onClick={() => this.handelShowModal()}
            >
              <img src={PlusIcon} alt="Plus" />
              Request Allergy
            </Link>
          )}
          {userType === 'patient' && !sharedToken && (
            <Add
              to={`/allergy/new${
                RequestConsultation ? '?RequestConsultation=1' : ''
              }`}
            />
          )}
          {allergies &&
            allergies.data.map(allergy => (
              <StateCard
                to={
                  userType === 'consultant'
                    ? `/consultation/${consultationId}/allergy/${allergy.id}?patientId=${patientId}`
                    : sharedToken
                    ? `/allergies/${allergy.id}?patientId=${patientId}&sharedToken=${sharedToken}`
                    : `/allergies/${allergy.id}`
                }
                key={allergy.createdAt}
                title={allergy.value}
                time={allergy.createdAt}
              />
            ))}
          {allergies && allergies.meta.total > allergies.meta.per_page && (
            <Pagination
              pageSize={allergies.meta.per_page}
              total={allergies.meta.total}
              setPage={this.setPage}
            />
          )}
          <Modal
            title={'Request Allergy'}
            image={Lab}
            showModal={showModal}
            handelCloseModal={this.handelCloseModal}
          >
            <>
              <RequestMedicalRecordForm
                requestScan={requestScan}
                scanType={'allergy'}
                consultationId={Number(consultationId)}
                handelCloseModal={this.handelCloseModal}
              />
            </>
          </Modal>
        </AllergiesWrapper>
      </Container>
    );
  }
}

const mapStateToProps = state => {
  const { allergies } = state.allergies;
  return {
    allergies,
  };
};

const mapDispatchToProps = dispatch => ({
  getAllergies: (page = null) =>
    dispatch(patientAllergyActions.getAllergies(page)),
  getSharedAllergies: (patientId, sharedToken = null, page = null) =>
    dispatch(
      patientAllergyActions.getSharedAllergies(patientId, sharedToken, page)
    ),
  requestScan: ({ scanType, id, title, body }) =>
    dispatch(consultationActions.requestScan({ scanType, id, title, body })),
});

Allergies.propTypes = {
  getAllergies: PropTypes.func.isRequired,
  allergies: PropTypes.object,
  match: PropTypes.object.isRequired,
  getSharedAllergies: PropTypes.func.isRequired,
  requestScan: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Allergies);
